import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { api, useGetLeaderboardQuery } from '../../store/api/api';
import { ThreadExcerpt } from './ThreadExcerpt';
import { NewThreadDialog } from './newThread/NewThreadDialog';
import { InlineNewThreadButton } from './newThread/InlineNewThreadButton';
import { AddCommentDialog } from './comments/AddCommentDialog';
import {
  selectThreadsByUser,
  useGetThreadsQuery,
} from '../../store/api/threadsApi';
import { useGetUsersQuery } from '../../store/api/usersApi';
import { ProfileHeader } from './users/ProfileHeader';
import { UserPageSkeleton } from './transitions/UserPageSkeleton';

export function Yours() {
  const dispatch = useDispatch();
  const {
    isUninitialized: threadsNotLoadedYet,
    isLoading: loadingThreads,
    data: threadsData,
    isError: loadingThreadsFailed,
  } = useGetThreadsQuery();

  const {
    isUninitialized: usersNotLoadedYet,
    isLoading: loadingUsers,
    data: users,
    isError: loadingUsersFailed,
  } = useGetUsersQuery();

  const { isUninitialized: leaderboardNotLoadedYet, data: leaderboard } =
    useGetLeaderboardQuery();

  const { currentUser } = useSelector((state) => state.auth);
  const threads = useSelector((state) =>
    selectThreadsByUser(state, currentUser.id)
  );

  const [score, setScore] = useState(0);

  useEffect(() => {
    if (threadsNotLoadedYet) dispatch(api.endpoints.getThreads.initiate());
    if (usersNotLoadedYet) dispatch(api.endpoints.getUsers.initiate());
    if (leaderboardNotLoadedYet)
      dispatch(api.endpoints.getLeaderboard.initiate());

    let userStat;
    if (leaderboard)
      userStat = leaderboard.find(({ user }) => user.id === currentUser.id);

    if (userStat) setScore(userStat.score);
  }, [
    currentUser.id,
    dispatch,
    leaderboard,
    leaderboardNotLoadedYet,
    threadsNotLoadedYet,
    usersNotLoadedYet,
  ]);

  return (
    <section className="container mx-auto mt-8 max-w-[600px] break-words 2xl:max-w-2xl">
      {loadingThreads && loadingUsers ? <UserPageSkeleton /> : ''}

      {threadsData && users ? (
        <>
          <ProfileHeader
            ava={currentUser.avatar}
            id={currentUser.id}
            name={currentUser.name}
            email={currentUser.email}
            score={score}
          />
          <InlineNewThreadButton />
          <NewThreadDialog />
          {threads.length > 0 ? (
            <>
              <h2 className="mt-4 mb-4 text-lg font-semibold">Your Threads</h2>
              <ul className="mb-10 grid divide-y divide-gray-200 overflow-hidden dark:divide-gray-800">
                {threads.map((thread) => (
                  <li
                    key={thread.id}
                    className="py-2 hover:bg-indigo-500/5 dark:hover:bg-indigo-900/5"
                  >
                    <ThreadExcerpt thread={thread} />
                  </li>
                ))}
              </ul>
            </>
          ) : (
            <div className="grid h-80 place-items-center text-center">
              Your threads will appear here <br />
              once you created it
            </div>
          )}
        </>
      ) : (
        ''
      )}
      {loadingThreadsFailed || loadingUsersFailed ? (
        <div className="my-4">Nothing to see here</div>
      ) : (
        ''
      )}
      <AddCommentDialog />
    </section>
  );
}
